// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"23":"2201d8fb","229":"3780e7aa"}[chunkId] + ".chunk.js");